import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireLink} from '../umpire-link';

export interface UmpireComponentHeader
  extends UmpireComponent<UmpireComponentTypeEnum.PAGE_HEADER> {
  links: UmpireLink[];
}
